/* eslint-disable @typescript-eslint/no-explicit-any */
import { Profile } from '../../components/font-end/Profile/Profile';
import { NewsHighlight } from '../../components/font-end/HomeNews/NewsHighlight';
import { TimeInOut } from '../../components/font-end/TimeInfo/TimeInOut';
import { PayrollCutoff } from '../../components/font-end/PayrollCalendar/PayrollCutoff';
import { PayrollCutoffLastDowload } from '../../components/font-end/PayrollCalendar/PayrollCutoffLastDowload';
import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { useUser } from '../../context/UserContext';

export const Home = () => {
  const { userInfo, isLoading } = useUser();
  const userReady = !isLoading && !!userInfo;

  // News, payroll and calendar do not need the user's profile, so they are mounted (and start loading) right away,
  // but kept hidden until the profile is ready: the page then appears whole instead of half-built.
  return (
    <>
      {!userReady && (
        <div className="layout-loading">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div style={userReady ? undefined : { display: 'none' }}>
        {userReady && <Profile />}
        <NewsHighlight />
        {userReady && <TimeInOut renderBxo="none" />}
        <PayrollCutoff />
        <PayrollCutoffLastDowload />
        <Menubar />
      </div>
    </>
  );
};
